module.exports = __webpack_public_path__ + "na_rights.2218d70124fb55bda5d18bd8e1cc5c2b.svg";